import { Component } from "solid-js";
import PricingCards from "../components/PricingCards";

const Pricing: Component = () => (
  <section class="internal-pricing">
    <div class="page-eyebrow">MEMBERSHIP</div>
    <h1>Unlock the complete analysis.</h1>
    <p class="page-intro">Create an account for free. Upgrade for full mathematical probability estimates, statistical edge comparisons and complete race cards.</p>
    <PricingCards />
  </section>
);

export default Pricing;
